import pluralize from 'pluralize';

import { bold, Summary } from './primitives';
import type { SummarySlice } from './types';

export const guidanceSummaries = {
  'guidance.scan_completed': ({ entry }) =>
    entry.count === 0 ? (
      <Summary>Contract guidance scan found no suggestions</Summary>
    ) : (
      <Summary>
        Contract guidance scan found&nbsp;{bold(String(entry.count))}&nbsp;{pluralize('suggestion', entry.count)} to
        review
      </Summary>
    ),
  'guidance.suggestion_resolved': ({ entry }) =>
    entry.source === 'AI' ? (
      <Summary>Contract guidance suggestion resolved by the guidance re-check</Summary>
    ) : (
      <Summary>Contract guidance suggestion resolved</Summary>
    ),
  'guidance.suggestion_dismissed': () => <Summary>Contract guidance suggestion dismissed</Summary>,
} satisfies SummarySlice;
